import React, { useState } from 'react';
import styles from './TransportBlock.module.scss';
import { useTransports } from '../../api/queries/transports';
import { Spin } from 'antd';
import useTransportPermitsMatch from '../../../../shared/hooks/useTransportPermitsMatch';
import EmptyCard from '../../../../shared/ui/EmptyCard/EmptyCard';
import DataTable from '../../../../shared/ui/DataTable/DataTable';
import useTableChange from '../../../../shared/hooks/useTableChange';
import { getTableColumns } from '../../lib/getTableColumns';
import { sortableColumnsData } from '../../../../shared/constants/sortableColumnsData';
import useTablePagination from '../../../../shared/hooks/useTablePagination';
import TransportsExpandedRow from '../TransportsExpandedRow/TransportsExpandedRow';
import useFilteredBySearchDataTransportPermits from '../../../../shared/hooks/useFilteredBySearchDataTransportPermits';
import { modes } from '../../../../shared/components/Search/constants';

const TransportBlock = () => {
  const match = useTransportPermitsMatch();

  const urlCompanyId = match?.params.companyId
    ? Number(match.params.companyId)
    : null;

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const { data: transports = [], isFetching } = useTransports(urlCompanyId, {
    enabled: !!urlCompanyId,
    select: (data) => data.slice().reverse(),
  });

  const isEmpty = !transports || !transports?.length;

  const [loading, filteredBySearchTransports] =
    useFilteredBySearchDataTransportPermits({
      data: transports,
      mode: modes.transports,
    });

  const {
    data: filteredAndSorted,
    sortedInfo,
    handleTableChange,
  } = useTableChange({
    initialData: filteredBySearchTransports,
    sortableColumnKeys: sortableColumnsData,
    depsToReset: [urlCompanyId],
  });

  const { shownItems: shownTenants, pagination: paginationBlock } =
    useTablePagination(filteredAndSorted);

  const columns = getTableColumns({ sortedInfo, expandedRowKeys });

  const removeRowFromSelection = (rowId) => {
    const updateRowKeys = expandedRowKeys.filter((key) => key !== rowId);
    setExpandedRowKeys(updateRowKeys);
  };

  const addRowToSelection = (rowId) => {
    const updateRowKeys = [...expandedRowKeys, rowId];
    setExpandedRowKeys(updateRowKeys);
  };

  const handleRowClick = (rowId) => {
    if (expandedRowKeys.includes(rowId)) {
      removeRowFromSelection(rowId);
    } else {
      addRowToSelection(rowId);
    }
  };

  return (
    <Spin spinning={isFetching || loading}>
      <article className={styles.container}>
        {isEmpty ? (
          <EmptyCard description="У выбранной компании отсутствуют ТС" />
        ) : (
          <DataTable
            onChange={handleTableChange}
            columns={columns}
            dataSource={shownTenants}
            paginationBlock={paginationBlock}
            rowKey={(record, index) => {
              return record.transport?.id || `row-${index}`;
            }}
            expandIconAsCell={false}
            expandedRowKeys={expandedRowKeys}
            expandedRowRender={(record) => (
              <TransportsExpandedRow record={record} />
            )}
            onRow={(record) => ({
              onClick: () => handleRowClick(record.transport?.id),
              expanded: expandedRowKeys.includes(record.transport?.id),
            })}
          />
        )}
      </article>
    </Spin>
  );
};

export default TransportBlock;
